import { BrowserRouter } from "react-router-dom";
import { AppRoutes } from "./router";
import { I18nextProvider } from "react-i18next";
import i18n from "./i18n";
import ScrollManager from "@/components/feature/ScrollManager";
import Effects from "@/components/feature/Effects";
import LangSync from "@/components/feature/LangSync";
import Analytics from "@/components/feature/Analytics";

function App() {
  return (
    <I18nextProvider i18n={i18n}>
      <BrowserRouter basename={__BASE_PATH__}>
        <LangSync />
        <Analytics />
        <ScrollManager />
        <Effects />
        <AppRoutes />
      </BrowserRouter>
    </I18nextProvider>
  );
}

export default App;
